import {
  DATES_LOADING_ADDRESS,
  DOCTORS_NAMES_LOADING_ADDRESS,
  DOCTORS_SPECIALITIES_LOADING_ADDRESS,
  R_N_M_FIRST_STEP_ADDRESS,
  R_N_M_FOURTH_STEP_ADDRESS,
} from "../../variables";
import {
  MOSCOW_PATIENT_VALIDATION_FAILED,
  MOSCOW_PATIENT_VALIDATION_SUCCESS,
  MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_FAILED,
  MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_SUCCESS,
  MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_FAILED,
  MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_SUCCESS,
  MOSCOW_SCENARIO_ORDER_ID_FAILED,
  MOSCOW_SCENARIO_ORDER_ID_SUCCESS,
  MOSCOW_SCENARIO_REGIONS_BANS_FOUND,
  MOSCOW_SCENARIO_REGIONS_BANS_NOT_FOUND,
  MOSCOW_SCENARIO_SELECT_DOCTOR_NAME,
  MOSCOW_SCENARIO_SELECT_SPECIALITY,
  MOSCOW_SPECIALITIES_LOADING_FAILED,
  MOSCOW_SPECIALITIES_LOADING_SUCCESS,
} from "./types";
import {
  hideMoscowScenarioLoader,
  showMoscowScenarioLoader,
} from "./loaderActions";
import { replaceAllDivisiosToDots } from "../../utils";
import { datesLoadingSuccess } from "./datesActions";
import Api from "../../api";

import store from "../store";

export const checkRegionForBans = (OKATO) => (dispatch) => {
  const apiBase = store.getState().addresses.apiBase;

  let config = {
    method: "get",
    headers: {
      Accept: "application/json, text/plain, */*",
    },
    withCredentials: true,
  };
  dispatch(showMoscowScenarioLoader());
  Api.instance
    .get(R_N_M_FOURTH_STEP_ADDRESS + OKATO + "/service/10068?_=" + Math.random(), config)
    .then(() => {
      dispatch(regionBansNotFound());
    })
    .catch(() => {
      dispatch(regionBansFound());
      dispatch(hideMoscowScenarioLoader());
    });
};

export const regionBansNotFound = () => {
  return {
    type: MOSCOW_SCENARIO_REGIONS_BANS_NOT_FOUND,
  };
};

export const regionBansFound = () => {
  return {
    type: MOSCOW_SCENARIO_REGIONS_BANS_FOUND,
  };
};

export const startOrderIdLoading = () => (dispatch, getState) => {
  const detectedRegion = getState().regionAndMedicalOrganisation.detectedRegion;

  const data = {
    "userSelectedRegion" : detectedRegion?.OKATO,
    "eServiceCode": "10000103595",
    "serviceTargetCode": "-10000000633"
  }

  dispatch(showMoscowScenarioLoader());

  Api.instance
    .post(R_N_M_FIRST_STEP_ADDRESS, data)
    .then((response) => {
      dispatch(orderIdLoadingSuccess(response.data.id));
    })
    .catch((error) => {
      dispatch(orderIdLoadingFailed(error));
      dispatch(hideMoscowScenarioLoader());
    });
};

export const orderIdLoadingSuccess = (orderId) => {
  return {
    type: MOSCOW_SCENARIO_ORDER_ID_SUCCESS,
    payload: orderId,
  };
};

export const orderIdLoadingFailed = (error) => {
  return {
    type: MOSCOW_SCENARIO_ORDER_ID_FAILED,
    payload: error,
  };
};

export const patientValidation = (userInfo) => (dispatch) => {
  const apiBase = store.getState().addresses.apiBase;
  const [series, number] = getOMSSeriesAndNumber(getOMS(userInfo));
  let data = {
    eserviceId: "33090",
    userSelectedRegion: "45000000000",
    refName: "ValidatePerson",
    parentRefItemValue: null,
    treeFiltering: "ONELEVEL",
    selectAttributes: ["Patient_Id"],
    filter: {
      simple: null,
      union: {
        unionKind: "AND",
        subs: [
          {
            simple: {
              attributeName: "First_Name",
              condition: "EQUALS",
              checkAllValues: false,
              value: userInfo.firstName,
            },
            union: null,
          },
          {
            simple: {
              attributeName: "Last_Name",
              condition: "EQUALS",
              checkAllValues: false,
              value: userInfo.lastName,
            },
            union: null,
          },
          {
            simple: {
              attributeName: "Middle_Name",
              condition: "EQUALS",
              checkAllValues: false,
              value: userInfo.middleName,
            },
            union: null,
          },
          {
            simple: {
              attributeName: "Sex",
              condition: "EQUALS",
              checkAllValues: false,
              value: userInfo.gender || "M",
            },
            union: null,
          },
          {
            simple: {
              attributeName: "OMS_Number",
              condition: "EQUALS",
              checkAllValues: false,
              value: number,
            },
            union: null,
          },
          {
            simple: {
              attributeName: "OMS_Series",
              condition: "EQUALS",
              checkAllValues: false,
              value: series,
            },
            union: null,
          },
          {
            simple: {
              attributeName: "Birthdate",
              condition: "EQUALS",
              checkAllValues: false,
              value:
                replaceAllDivisiosToDots(userInfo.birthDate) || "01.01.1970",
            },
            union: null,
          },
          {
            simple: {
              attributeName: "SNILS",
              condition: "EQUALS",
              checkAllValues: false,
              value: userInfo.snils,
            },
            union: null,
          },
          {
            simple: {
              attributeName: "Reg_Code",
              condition: null,
              checkAllValues: false,
              value: "77",
            },
            union: null,
          },
          {
            simple: {
              attributeName: "Session_Id",
              condition: null,
              checkAllValues: false,
              value: userInfo.sessionId,
            },
            union: null,
          },
        ],
      },
    },
    orderBy: [],
    pageNum: 0,
    pageSize: 0,
    version: null,
    parentOrderId: 966845615,
    serviceCode: null,
    routeNumber: null,
    params: [
      {
        name: "region",
        value: "77",
      },
    ],
  };

  const config = {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    }
  };
  dispatch(showMoscowScenarioLoader());
  Api.instance
    .post(DOCTORS_NAMES_LOADING_ADDRESS, data, config)
    .then((response) => {
      console.log(response.data);
      if (response.data.error) {
        throw new Error(response.data.error.errorDetail.errorMessage);
      }
      dispatch(
        patientValidationSuccess(response.data.items[0].attributes[0].value)
      );
    })
    .catch((error) => {
      dispatch(patientValidationFailed(error));
    })
    .finally(() => dispatch(hideMoscowScenarioLoader()));
};

const patientValidationSuccess = (patientId) => {
  return {
    type: MOSCOW_PATIENT_VALIDATION_SUCCESS,
    payload: patientId,
  };
};

const patientValidationFailed = (error) => {
  return {
    type: MOSCOW_PATIENT_VALIDATION_FAILED,
    payload: error,
  };
};

const getOMSSeriesAndNumber = (omsString) => {
  omsString = omsString.trim();
  const spaceIndex = omsString.indexOf(" ");
  if (spaceIndex > 0) {
    return [
      omsString.substring(0, spaceIndex),
      omsString.substring(spaceIndex + 1, omsString.length),
    ];
  } else {
    return ["", omsString];
  }
};

const getOMS = (userInfo) => {
  const docs = userInfo.person.docs;
  for (let i = 0; i < docs.length; i++) {
    if (docs[i].type === "MDCL_PLCY") {
      return docs[i].number || "";
    }
  }
  return "";
};

export const doctorSpecialitiesLoading = (userInfo, orderId) => (dispatch) => {
  const apiBase = store.getState().addresses.apiBase;
  const data = {
    eserviceId: "33090",
    refName: "ServiceOrSpecs",
    treeFiltering: "ONELEVEL",
    selectAttributes: ["Service_Id", "Service_Name"],
    filter: {
      union: {
        unionKind: "AND",
        subs: [
          {
            simple: {
              attributeName: "Session_Id",
              condition: "EQUALS",
              value: userInfo.sessionId,
            },
          },
        ],
      },
    },
    pageNum: 0,
    pageSize: 0,
    params: [
      {
        name: "orderId",
        value: orderId,
      },
      {
        name: "region",
        value: "77",
      },
    ],
  };

  const config = {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  };
  dispatch(showMoscowScenarioLoader());
  Api.instance
    .post(DOCTORS_SPECIALITIES_LOADING_ADDRESS, data, config)
    .then((resp) => {
      if (resp.data.error) {
        throw new Error(resp.data.error.errorMessage);
      }
      const doctorSpecialities = resp.data.items.map(mapLoadedSpecialities);
      dispatch(doctorSpecialitiesLoadingSuccess(doctorSpecialities));
    })
    .catch((error) => {
      dispatch(doctorSpecialitiesLoadingFailed(error));
    })
    .finally(() => {
      dispatch(hideMoscowScenarioLoader());
    });
};
const mapLoadedSpecialities = (speciality) => {
  return {
    [speciality.attributes[0].name]: speciality.attributes[0].value,
    [speciality.attributes[1].name]: speciality.attributes[1].value,
  };
};
export const doctorSpecialitiesLoadingSuccess = (specialities) => {
  return {
    type: MOSCOW_SPECIALITIES_LOADING_SUCCESS,
    payload: specialities,
  };
};

export const doctorSpecialitiesLoadingFailed = (error) => {
  return {
    type: MOSCOW_SPECIALITIES_LOADING_FAILED,
    payload: error,
  };
};

export const selectSpeciality = (speciality) => {
  return {
    type: MOSCOW_SCENARIO_SELECT_SPECIALITY,
    payload: speciality,
  };
};

export const loadDoctorNames = (selectedSpeciality, sessionId, orderId) => (
  dispatch
) => {
  const apiBase = store.getState().addresses.apiBase;
  const data = {
    eserviceId: "33090",
    refName: "Resource",
    treeFiltering: "ONELEVEL",
    selectAttributes: ["Resource_Id", "Resource_Name"],
    filter: {
      union: {
        unionKind: "AND",
        subs: [
          {
            simple: {
              attributeName: "Service_Id",
              condition: "EQUALS",
              value: selectedSpeciality.Service_Id,
            },
          },
          {
            simple: {
              attributeName: "Session_Id",
              condition: "EQUALS",
              value: sessionId,
            },
          },
        ],
      },
    },
    pageNum: 0,
    pageSize: 0,
    params: [
      {
        name: "orderId",
        value: orderId,
      },
      {
        name: "region",
        value: "77",
      },
    ],
  };

  const config = {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  };
  dispatch(showMoscowScenarioLoader());
  Api.instance
    .post(DOCTORS_NAMES_LOADING_ADDRESS, data, config)
    .then((response) => {
      if (response.data.error) {
        throw new Error(response.data.error.errorMessage);
      }
      if (response.data.totalItems === 0) {
        throw new Error("Нет доступных врачей");
      }
      const doctorNames = response.data.items.map(mapLoadedDoctorName);
      dispatch(loadDoctorNamesSuccess(doctorNames));
    })
    .catch((error) => {
      dispatch(loadDoctorNamesFailed(error));
    })
    .finally(() => dispatch(hideMoscowScenarioLoader()));
};

const mapLoadedDoctorName = (doctorName) => {
  return {
    [doctorName.attributes[0].name]: doctorName.attributes[0].value,
    [doctorName.attributes[1].name]: doctorName.attributes[1].value,
  };
};

export const loadDoctorNamesSuccess = (doctors) => {
  return {
    type: MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_SUCCESS,
    payload: doctors,
  };
};

export const loadDoctorNamesFailed = (error) => {
  return {
    type: MOSCOW_SCENARIO_LOAD_DOCTOR_NAMES_FAILED,
    payload: error,
  };
};

export const selectDoctorName = (doctorName) => {
  return {
    type: MOSCOW_SCENARIO_SELECT_DOCTOR_NAME,
    payload: doctorName,
  };
};

export const loadMedicalOrganisations = (
  sessionId,
  selectedDoctorName,
  orderId
) => (dispatch) => {
  const apiBase = store.getState().addresses.apiBase;
  let data = {
    treeFiltering: "ONELEVEL",
    pageNum: "1",
    pageSize: "9999",
    filter: {
      union: {
        unionKind: "AND",
        subs: [
          {
            simple: {
              attributeName: "eserviceId",
              condition: "EQUALS",
              value: {
                asString: "33090",
              },
            },
          },
          {
            simple: {
              attributeName: "scenarioType",
              condition: "EQUALS",
              value: {
                asString: "1",
              },
            },
          },
          {
            simple: {
              attributeName: "Session_Id",
              condition: "EQUALS",
              value: {
                asString: sessionId,
              },
            },
          },
          {
            simple: {
              attributeName: "Resource_Id",
              condition: "EQUALS",
              value: {
                asString: selectedDoctorName.Resource_Id,
              },
            },
          },
          {
            simple: {
              attributeName: "orderId",
              condition: "EQUALS",
              value: {
                asString: orderId,
              },
            },
          },
          {
            simple: {
              attributeName: "Reg_Code",
              condition: "EQUALS",
              value: {
                asString: "77",
              },
            },
          },
        ],
      },
    },
    parentRefItemValue: "",
    selectAttributes: ["*"],
  };

  let config = {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  };
  dispatch(showMoscowScenarioLoader());
  Api.instance
    .post("/nsi/v1/dictionary/mzrf_equeue_lpu", data, config)
    .then((response) => {
      if (response.data.error.code > 0) {
        throw new Error(response.data.error.message);
      }
      dispatch(
        loadMedicalOrganisationSuccess(response.data.items[0].attributeValues)
      );
    })
    .catch((error) => {
      dispatch(loadMedicalOrganisationFailed(error));
    })
    .finally(() => dispatch(hideMoscowScenarioLoader()));
};

export const loadMedicalOrganisationSuccess = (medicalOrganisations) => {
  return {
    type: MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_SUCCESS,
    payload: medicalOrganisations,
  };
};

export const loadMedicalOrganisationFailed = (error) => {
  return {
    type: MOSCOW_SCENARIO_LOAD_MEDICAL_ORGANISATION_FAILED,
    error: error,
  };
};

export const loadSlots = (
  medicalOrganisationId,
  sessionId,
  doctorId,
  startDate,
  endDate
) => (dispatch) => {
  const apiBase = store.getState().addresses.apiBase;

  let data = {
    eserviceId: "33090",
    serviceId: ["10001000603"],
    serviceCode: "-10001000603",
    organizationId: [medicalOrganisationId],
    parentOrderId: "",
    caseNumber: "967526304",
    attributes: [
      {
        name: "Session_Id",
        value: sessionId,
      },
      {
        name: "Resource_Id",
        value: doctorId,
      },
      {
        name: "MO_Id",
        value: medicalOrganisationId,
      },
      {
        name: "Startdate",
        value: startDate,
      },
      {
        name: "Enddate",
        value: endDate,
      },
      {
        name: "Starttime",
        value: "00:00",
      },
      {
        name: "Endtime",
        value: "23:59",
      },
    ],
  };

  let config = {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  };
  dispatch(showMoscowScenarioLoader());
  Api.instance
    .post(DATES_LOADING_ADDRESS, data, config)
    .then((response) => {
      if (
        response.data.error &&
        response.data.error.errorDetail.errorCode > 0
      ) {
        throw new Error(response.data.error.errorDetail.errorMessage);
      }
      dispatch(datesLoadingSuccess(response.data.slots));
    })
    .catch((error) => {})
    .finally(() => dispatch(hideMoscowScenarioLoader()));
};
